<ng-container *ngIf="!to.hasRepeatButtons; else repeat">
  <div class="p-4 w-full flex-row justify-start items-start gap-4 inline-flex">
    <div class="text-black text-lg font-bold leading-normal">{{ to.label }}</div>
    <div class="flex items-center cursor-pointer ml-auto">
      <button
        *ngIf="to.hasCsvImport"
        xilo-button
        (click)="openDromo()"
      >
        <div class="flex justify-center items-center">
          <mat-icon class="text-lg -mt-1">description</mat-icon>
          <div class="text-sm pl-1">Import CSV</div>
        </div>
      </button>
    </div>
  </div>
  <xilo-accordion class="flex flex-col rounded bg-white">
    <xilo-accordion-panel [attr.id]="field?.id" [open]="openedAccordion?.has(field?.id)" (openChanged)="openChanged($event)">
      <xilo-accordion-title>
        <div class="flex flex-row w-full pr-2">
          <span>{{ to.label }}</span>
          <mat-icon class="text-lg -mt-1 ml-2 text-red-500" *ngIf="!field?.formControl?.valid">
            warning
          </mat-icon>
        </div>
      </xilo-accordion-title>
      <xilo-accordion-content>
        <ng-container #fieldComponent></ng-container>
      </xilo-accordion-content>
    </xilo-accordion-panel>
  </xilo-accordion>

  <xilo-mono-csv-importer
    #importer
    [importerName]="to.label"
    [licenseKey]="dromoLicenseKey"
    (cancelled)="onCancelImport()"
    (completed)="onCompletedImport($event)"
    [user]="activeUser"
  ></xilo-mono-csv-importer>
</ng-container>
<ng-template #repeat>
  <div class="flex flex-col bg-white">
    <ng-container #fieldComponent></ng-container>
  </div>
</ng-template>
